import React, { Fragment } from 'react'
import { View, Text, Image } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import TableGrid from './TableGrid'
import LeftSectionTitle from './LeftSectionTitle'
import RightSectionTitle from './RightSectionTitle'
import BoxLeft from './BoxLeft'
import BoxRight from './BoxRight'
import SectionTitle from './SectionTitle'
import { themeConfig } from '../../config/theme.config'

const SafetyMeasuresTable = ({ safetyMeasuresArr, reportTickImgDataUrl }) => {
  const parent = {
    width: '100%',
    maxWidth: '100%',
    textAlign: 'center',

    fontFamily: 'Roboto'
  }
  const safetyMeasuresFields = ['Countermeasures', 'Mode', 'Implemented']

  return (
    <View style={[parent]} debug={false} fixed={true}>
      <TableGrid>
        {safetyMeasuresFields.map((field, i) => {
          if (i === 0) {
            return (
              <LeftSectionTitle
                leftTitle={field}
                width="50%"
                key={`${field}_${i}_report`}
              />
            )
          } else {
            return (
              <RightSectionTitle
                rightTitle={field}
                width="25%"
                key={`${field}_${i}_report`}
              />
            )
          }
        })}
      </TableGrid>

      {safetyMeasuresArr.map((measure, index) => {
        return (
          <TableGrid key={`${measure.name}_report`}>
            <BoxLeft
              value={measure.name}
              width="50%"
              color={themeConfig.semcogBlue1}
              textAlign="left"
            />

            <BoxRight
              value={measure.mode}
              width="25%"
              color={themeConfig.semcogBlue1}
              reportTickImgDataUrl={reportTickImgDataUrl}
            />
            <BoxRight
              value={measure.isMeasureImplemented ? 'YES' : 'NO'}
              width="25%"
              color={themeConfig.semcogBlue1}
              reportTickImgDataUrl={reportTickImgDataUrl}
            />
          </TableGrid>
        )
      })}
      <TableGrid key="total_no_measures_report">
        <BoxLeft
          value="Total number of countermeasures implemented"
          width="75%"
          color={themeConfig.semcogBlue1}
          textAlign="left"
        />

        <BoxRight
          value={safetyMeasuresArr.reduce(
            (sum, measure) => (measure.isMeasureImplemented ? sum + 1 : sum),
            0
          )}
          width="25%"
          color={themeConfig.semcogBlue1}
          reportTickImgDataUrl={reportTickImgDataUrl}
        />
      </TableGrid>
    </View>
  )
}

export default SafetyMeasuresTable

SafetyMeasuresTable.propTypes = {
  safetyMeasuresArr: PropTypes.array.isRequired,
  reportTickImgDataUrl: PropTypes.string
}
